import { Component, Input, OnInit } from '@angular/core';
import { DeliverySystemConfiguration } from '@interfaces/delivery-system';
import { DeliveryZoneInd, Zone } from '@interfaces/rest/interfaces/zone';
import { ModalController } from '@ionic/angular';
import { ProvinceService } from '@services/province.service';

@Component({
  selector: 'app-config-delivery-system',
  templateUrl: './config-delivery-system.component.html',
  styleUrls: ['./config-delivery-system.component.scss'],
})
export class ConfigDeliverySystemComponent implements OnInit {
  @Input() zones: Zone[] = [];
  @Input() currentZone!: Zone;
  @Input() delivery: DeliveryZoneInd[] = [];

  deliveryListZone: DeliverySystemConfiguration[] = ['FIRST', 'CLOSEST_IN_ZONE_NO_SERVICE', 'CLOSEST_IN_ZONE_WITH_SERVICE'];
  deliveryListZoneWithoutParada: DeliverySystemConfiguration[] = ['CLOSEST_IN_ZONE_NO_SERVICE', 'CLOSEST_IN_ZONE_WITH_SERVICE'];

  constructor(private province: ProvinceService,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    console.log('zones', this.zones);
    console.log('delivery', this.delivery);
  }

  getZoneName(id: string) {
    return this.province.getZoneNameById(id);
  }

  dismiss() {
    this.modalController.dismiss();
  }

  getDeliveryTypeList(zoneId: string) {
    const zone = this.zones.find(elem => elem._id === zoneId)!;
    return zone.paradaRef ? this.deliveryListZone : this.deliveryListZoneWithoutParada;
  }

  addLine() {
    this.delivery.push({
      startTime: '00:00',
      endTime: '23:59',
      zone: this.currentZone._id,
      type: this.currentZone.paradaRef ? 'FIRST' : 'CLOSEST_IN_ZONE_NO_SERVICE'
    });
  }

  removeLine(index: number) {
    this.delivery.splice(index, 1);
  }

  saveDeliverySystem() {
    this.modalController.dismiss({ deliverySystem: this.delivery });
  }

  doReorder(event: any) {
    const itemMove = this.delivery.splice(event.detail.from, 1)[0];
    this.delivery.splice(event.detail.to, 0, itemMove);
    event.detail.complete();
  }

}
